import { __awaiter, __generator, __read } from "tslib";
import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { resources } from "../resources";
import { capturePaypalOrder, env, fetchPaypalOrderId } from "../request";
var messages = resources.getStrings();
var PaypalForm = function (_a) {
    var clientId = _a.clientId, currency = _a.currency, onPaymentSelected = _a.onPaymentSelected, onPaymentCanceled = _a.onPaymentCanceled, onPaymentError = _a.onPaymentError, onPaymentConfirmed = _a.onPaymentConfirmed;
    var _b = __read(useState(false), 2), loaded = _b[0], setLoaded = _b[1];
    var _c = __read(useState(false), 2), processing = _c[0], setProcessing = _c[1];
    var _d = __read(useState(), 2), error = _d[0], setError = _d[1];
    useEffect(function () {
        var sdkUrl = 'https://www.paypal.com/sdk/js?currency=' + currency + '&client-id=' + clientId;
        sdkUrl += '&disable-funding=card,credit,venmo,sepa,bancontact,eps,giropay,ideal,mybank,p24,sofort';
        var paypalScript = document.createElement('script');
        paypalScript.setAttribute('type', 'text/javascript');
        paypalScript.setAttribute('src', sdkUrl);
        var head = document.getElementsByTagName('head').item(0);
        if (head) {
            head.appendChild(paypalScript);
        }
        var tries = 0;
        var loadInterval = setInterval(function () {
            tries += 1;
            if (window['paypal']) {
                clearInterval(loadInterval);
                var paypal = window['paypal'];
                paypal.Buttons({
                    style: {
                        color: 'silver'
                    },
                    createOrder: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    setProcessing(true);
                                    onPaymentSelected();
                                    return [4 /*yield*/, fetchPaypalOrderId(env.paymentId)];
                                case 1: return [2 /*return*/, _a.sent()];
                                case 2:
                                    error_1 = _a.sent();
                                    console.error(error_1);
                                    setError(messages.PaypalFailedToCreateOrder);
                                    onPaymentError(error_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                    onApprove: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var status_1, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, capturePaypalOrder(env.paymentId)];
                                case 1:
                                    status_1 = _a.sent();
                                    setProcessing(false);
                                    onPaymentConfirmed(status_1);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_2 = _a.sent();
                                    console.error(error_2);
                                    setError(messages.PaypalFailedToCaptureOrder);
                                    onPaymentError(error_2);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                    onCancel: function () {
                        setProcessing(false);
                        onPaymentCanceled();
                    }
                }).render('#paypal-button-container');
                setLoaded(true);
            }
            if (tries > 10) {
                setError(messages.PaypalFailedToLoad);
                clearInterval(loadInterval);
            }
        }, 1000);
    }, []);
    return (React.createElement("div", { style: { flexGrow: 1 } },
        (!loaded && !error) && (React.createElement(Typography, { variant: "body1", color: "textSecondary" },
            React.createElement("i", null, messages.Loading))),
        (error) && (React.createElement(Typography, { variant: "body1", color: "textSecondary" }, error)),
        React.createElement("div", { id: "paypal-button-container", style: { display: (processing) ? 'none' : 'block' } }),
        processing && (React.createElement(Typography, { variant: "body1", align: "center" }, messages.ProcessingPayment))));
};
export function PaypalPayment(props) {
    return (React.createElement(PaypalForm, { clientId: props.publicKey, currency: props.currency, onPaymentSelected: props.onSelected, onPaymentCanceled: props.onCanceled, onPaymentError: props.onError, onPaymentConfirmed: props.onPaymentConfirmed }));
}
//# sourceMappingURL=paypal.js.map